/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { put, select } from 'redux-saga/effects';
import { selectOrg } from '@nebula/airglow-plugin-unified-shell/dist/selectors';
import { floodgateAPI } from '@nebula/corona-floodgate-plugin';
import { loadedFeatureFlags } from '../../common/actions';
import { featureFlagsLoaded } from '../data/prefabs';

const toggleFeatureFlags = () => featureFlagsLoaded.setAction;

export function* getFeatureFlags(force = false) {
  const orgId = yield select(selectOrg);
  floodgateAPI.flags.api.url = '/api/floodgate/?clientId=Nova&AM_OrgId={orgId}';
  yield put(floodgateAPI.flags({
    orgId,
    force,
    successActions: [toggleFeatureFlags, loadedFeatureFlags]
  }));
}
